// extracted by mini-css-extract-plugin
module.exports = {"caption":"caption_caption__ORTEW","captionRight":"caption_captionRight__8KsWb","captionCenter":"caption_captionCenter__2lCnF","captionGreen":"caption_captionGreen__3ndGd"};